export const makeUniqueArray = <T>(arrayWithDuplicates: T[]): T[] => {
  return arrayWithDuplicates.filter(
    (value, index, array) => array.indexOf(value) === index,
  );
};
